import { PageStructureEffect } from './page-structure/page-structure.effect';
import { BlocksEffects } from './blocks/blocks.effects';
import { SectionsEffects } from './sections/sections.effects';
import { ColumnsEffects } from './columns/columns.effects';
import { TabsEffects } from './tabs/tabs.effects';
import { GridsEffects } from '@web/store/page-structure/grids/grids.effects';
import { WidgetsEffects } from './widgets/widgets.effects';
import { WidgetsErrorsEffects } from './widgets-errors/widgets-errors.effects';

export const PageStructureEffects = [
    PageStructureEffect,
    BlocksEffects,
    SectionsEffects,
    ColumnsEffects,
    TabsEffects,
    GridsEffects,
    WidgetsEffects,
    WidgetsErrorsEffects,
];
